export type Locale = 'en' | 'ar';

export interface LocalText {
  readonly en: string;
  readonly ar: string;
}

export type ToolCategoryId =
  | 'organize'
  | 'optimize'
  | 'toPdf'
  | 'fromPdf'
  | 'edit'
  | 'security'
  | 'intelligence';

export type ProcessorId =
  | 'merge'
  | 'split'
  | 'remove-pages'
  | 'extract-pages'
  | 'organize'
  | 'scan'
  | 'compress'
  | 'repair'
  | 'ocr'
  | 'images-to-pdf'
  | 'docx-to-pdf'
  | 'pptx-to-pdf'
  | 'xlsx-to-pdf'
  | 'html-to-pdf'
  | 'pdf-to-images'
  | 'pdf-to-docx'
  | 'pdf-to-pptx'
  | 'pdf-to-xlsx'
  | 'pdf-to-pdfa'
  | 'rotate'
  | 'page-numbers'
  | 'watermark'
  | 'crop'
  | 'edit-overlay'
  | 'forms'
  | 'unlock'
  | 'protect'
  | 'sign'
  | 'redact'
  | 'compare'
  | 'summarize'
  | 'translate'
  | 'pdf-to-markdown';

export type OfflinePackId = 'ocr-en' | 'ocr-ar' | 'translate-en-ar' | 'summarize-multilingual';

export type OptionKind =
  | 'text'
  | 'password'
  | 'textarea'
  | 'number'
  | 'range'
  | 'select'
  | 'toggle'
  | 'color'
  | 'page-range';

export interface ToolOptionChoice {
  readonly value: string;
  readonly label: LocalText;
}

export interface ToolOptionDefinition {
  readonly key: string;
  readonly kind: OptionKind;
  readonly label: LocalText;
  readonly help?: LocalText;
  readonly defaultValue: string | number | boolean;
  readonly placeholder?: LocalText;
  readonly choices?: readonly ToolOptionChoice[];
  readonly min?: number;
  readonly max?: number;
  readonly step?: number;
  readonly sensitive?: boolean;
}

export interface AcceptedFileType {
  readonly label: LocalText;
  readonly mimeTypes: readonly string[];
  readonly extensions: readonly string[];
}

export interface OutputType {
  readonly mimeType: string;
  readonly extension: string;
  readonly label: LocalText;
}

export interface ToolDefinition {
  readonly id: ProcessorId;
  readonly category: ToolCategoryId;
  readonly route: string;
  readonly name: LocalText;
  readonly description: LocalText;
  readonly acceptedFileTypes: readonly AcceptedFileType[];
  readonly multipleFiles: boolean;
  readonly minimumFiles?: number;
  readonly processingAdapter: ProcessorId;
  readonly workerModule: string;
  readonly offlinePacks?: readonly OfflinePackId[];
  readonly outputs: readonly OutputType[];
  readonly warnings?: readonly LocalText[];
  readonly options: readonly ToolOptionDefinition[];
  readonly featured?: boolean;
  readonly tags: readonly LocalText[];
}

export interface ToolCategory {
  readonly id: ToolCategoryId;
  readonly name: LocalText;
  readonly description: LocalText;
}

export function localize(text: LocalText, locale: Locale): string {
  return text[locale];
}
